import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {Video} from '@models/partner';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent {

    video: Video
    constructor(
        public dialogRef: MatDialogRef<VideoComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.video = data.video
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
